import { ModelField, ModelGroup, ModelItem } from '../model-item';

export interface IModelHandler {
  processField(item: ModelField, level: number, index: number): void;

  processGroup(item: ModelGroup, level: number, index: number): void;

  endGroupProcessing?(item: ModelGroup, level?: number, index?: number);

  endProcessing?();
}

export class ModelProcessor {
  stopProcessing = false;
  groupLevel = 0;
  _ignoreItemsObject: { [path: string]: ModelItem };

  constructor(
    public model: ModelGroup,
    public handler: IModelHandler,
    public ignoreItems?: ModelItem[]
  ) {}

  process(): void {
    this.processGroupDetail(this.model, 0, 0);
    if (this.handler.endProcessing) {
      this.handler.endProcessing();
    }
  }

  processItems(model: ModelGroup): void {
    let groupCounter = 0;
    let fieldCounter = 0;

    if (this.stopProcessing || this.isItemToIgnore(model)) {
      return;
    }

    this.groupLevel++;

    model.children.forEach((item: ModelItem) => {
      if (this.stopProcessing || this.isItemToIgnore(item)) {
        return;
      }
      if (item instanceof ModelField) {
        ++fieldCounter;
        // console.log('process field', item.toString(), fieldCounter);
        this.handler.processField(item, this.groupLevel, fieldCounter);
      } else if (item instanceof ModelGroup) {
        this.processGroupDetail(item, this.groupLevel, ++groupCounter);
      }
    });
    this.groupLevel--;
  }

  get ignoreItemsObject(): { [path: string]: ModelItem } {
    if (!this._ignoreItemsObject) {
      const result = {};
      this.ignoreItems.forEach((item: ModelItem) => (result[item.path] = item));
      this._ignoreItemsObject = result;
    }
    return this._ignoreItemsObject;
  }

  isItemToIgnore(item: ModelItem): boolean {
    let result = false;
    if (this.ignoreItems) {
      result = !!this.ignoreItemsObject[item.path];
    }
    return result;
  }

  processGroupDetail(item: ModelGroup, level: number, index: number): void {
    // console.log('process group', item.toString(), groupCounter);
    this.handler.processGroup(item, this.groupLevel, index);
    this.processItems(item);
    if (this.handler.endGroupProcessing) {
      this.handler.endGroupProcessing(item, level, index);
    }
  }
}
